<template>
  <section>
    <!--列表-->
    <el-table
      :data="stationList"
      highlight-current-row
      v-loading="listLoading"
      style="width: 100%"
    >
      <el-table-column prop="Name" label="搅拌站名称"></el-table-column>
      <el-table-column
        prop="CreateTime"
        label="配置创建日期"
        :formatter="formatCreateTime"
      ></el-table-column>

      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-link
            type="primary"
            @click="
              currentRow = scope.row;
              showStation();
            "
          >
            搅拌站配置
          </el-link>
          <el-link
            type="primary"
            @click="
              currentRow = scope.row;
              showStationLine();
            "
          >
            生产线管理
          </el-link>
        </template>
      </el-table-column>
    </el-table>

    <!-- 搅拌站配置 -->
    <el-dialog
      :visible="stationArea"
      title="搅拌站配置"
      :before-close="hideStation"
    >
      <el-form :model="stationform" label-width="130px">
        <el-form-item label="数据传输接口">
          <el-input v-model="stationform.PlcServiceUrl"></el-input>
        </el-form-item>
        <el-form-item label="摄像头接口地址">
          <el-input v-model="stationform.CameraServiceAddress"></el-input>
        </el-form-item>
        <el-form-item label="LED接口地址">
          <el-input v-model="stationform.LedsServiceAddress"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="8">
            <el-form-item label="任务单必须合同">
              <el-switch
                v-model="stationform.TaskNeedContract"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="任务单必须配比">
              <el-switch
                v-model="stationform.TaskNeedRecipe"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="回站自动签收">
              <el-switch
                v-model="stationform.BackAutoSignedQuyantity"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item style="text-align: right">
          <el-button type="primary" @click="savestationform">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 生产线管理 -->
    <el-dialog
      :visible="stationLineArea"
      title="生产线管理"
      :before-close="hideStationLine"
    >
      <el-button type="primary" @click="showStationAddLine(false)">
        添加生产线
      </el-button>
      <el-table
        :data="stationLineList"
        highlight-current-row
        v-loading="listLoading"
        style="width: 100%"
      >
        <el-table-column
          align="center"
          prop="Name"
          label="生产线名称"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="ShortName"
          label="生产线简称"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="OnceQuantity"
          label="每盘方量"
        ></el-table-column>
        <el-table-column align="center" prop="IsEnable" label="状态">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.IsEnable == 0 ? 'info' : 'success'"
              disable-transitions
            >
              {{ scope.row.IsEnable == 0 ? "禁用" : "启用" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="CreateTime"
          label="配置创建日期"
          :formatter="formatCreateTime"
        ></el-table-column>

        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-link
              type="primary"
              @click="
                currentstationLineRow = scope.row;
                showStationAddLine(true);
              "
            >
              修改
            </el-link>
            <el-link type="danger" @click="removeStationLine(scope.row.Id)">
              删除
            </el-link>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 添加修改生产线 -->
    <el-dialog
      :visible="stationLineAddArea"
      title="生产线管理"
      :before-close="hideStationAddLine"
      width="800px"
      top="20vh"
    >
      <el-form :inline="true" :model="stationLineform" label-width="130px">
        <el-form-item label="生产线名称">
          <el-input v-model="stationLineform.Name"></el-input>
        </el-form-item>
        <el-form-item label="生产线简称">
          <el-input v-model="stationLineform.ShortName"></el-input>
        </el-form-item>
        <el-form-item label="每盘方量">
          <el-input v-model.number="stationLineform.OnceQuantity"></el-input>
        </el-form-item>

        <el-form-item label="数据库地址">
          <el-input v-model="stationLineform.DBAddress"></el-input>
        </el-form-item>

        <el-form-item label="数据库端口">
          <el-input v-model.number="stationLineform.DBPort"></el-input>
        </el-form-item>

        <el-form-item label="登录名称">
          <el-input v-model="stationLineform.DBUser"></el-input>
        </el-form-item>

        <el-form-item label="密码">
          <el-input v-model="stationLineform.DBPwd"></el-input>
        </el-form-item>
        <el-form-item label="数据库名称">
          <el-input v-model="stationLineform.ControlDBName"></el-input>
        </el-form-item>
        <el-form-item label="工控机类型">
          <el-select v-model="stationLineform.PlcType" placeholder="请选择">
            <el-option
              v-for="item in plcTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="工控机分类">
          <el-select v-model="stationLineform.PlcVer" placeholder="请选择">
            <el-option
              v-for="item in plcVerOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出货单打印Id">
          <el-input v-model="stationLineform.OutMasterPrintID"></el-input>
        </el-form-item>

        <el-form-item label="同步自动消耗" prop="stationLineform.SyncMaterial">
          <el-switch
            v-model="stationLineform.SyncMaterial"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </el-form-item>
        <el-form-item
          label="同步手动消耗"
          prop="stationLineform.SyncManualMaterial"
        >
          <el-switch
            v-model="stationLineform.SyncManualMaterial"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </el-form-item>
        <el-form-item label="是否启用" prop="stationLineform.IsEnable">
          <el-switch
            v-model="stationLineform.IsEnable"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="stationLineform.Remark"></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: right">
        <el-button type="primary" @click="saveStationLineform">保存</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import { createLogger } from "vuex";
import util from "../../../util/date";
// import {mixinmethods} from "@/mixin/methods";
import {
  getSysStationLineListPage,
  editSysStationLine,
  addSysStationLine,
  deleteSysStationLine,
  getSysStationListPage,
  editSysStation,
  addSysStation,
} from "../../api/station";

export default {
  data() {
    return {
      buttonList: [],
      currentRow: null, //选中列
      currentstationLineRow: null, //选中生产线管理列
      filters: {
        LinkUrl: "",
      },
      stationList: [],
      listLoading: false,
      stationArea: false, //搅拌站窗口是否显示
      stationLineArea: false, //生产线窗口是否显示
      stationLineAddArea: false, //生产线添加修改窗口是否显示
      stationform: {}, //搅拌站配置form

      stationLineList: [], //生产线列表信息
      stationLineform: {}, //生产线管理form
      stationLineformEdit: false, //生产线管理是否为修改 false为添加
      plcTypeOptions: [
        {
          value: 1,
          label: "三一线",
        }, {
          value: 3,
          label: "中联14标准版",
        },
        {
          value: 9,
          label: "博硕",
        },
        {
          value: 10,
          label: "CPDB",
        },{
          value: 20,
          label: "南方路机",
        },
      ],
      plcVerOptions: [
        {
          value: 1,
          label: "SQLServer库",
        },
        {
          value: 100,
          label: "MySql库",
        },{
          value: 200,
          label: "ACCESS库",
        },{
          value: 2,
          label: "中联Z7",
        },
      ],
      orgCode: "",
      orgID: "",
    };
  },
  computed: {},
  mounted() {
    if (localStorage.sysOrgs) {
      this.stationList = JSON.parse(localStorage.sysOrgs);
    }
  },
  methods: {
    //修改搅拌站窗口
    showStation() {
      this.stationArea = true;
      this.stationform = {};
      this.getSysStation();
    },
    getSysStation() {
      let para = {
        page: 1,
        key: this.currentRow.Id,
        intPageSize: 1,
      };
      getSysStationListPage(para).then((res) => {
        if (res.data.response.data && res.data.response.data.length > 0) {
          this.stationform = res.data.response.data[0];
        } else {
          this.stationform.OrgID = this.currentRow.Id;
          this.stationform.OrgCode = this.currentRow.OrgCode;
        }
      });
    },
    hideStation() {
      this.stationArea = false;
    },
    //修改搅拌站窗口
    showStationLine() {
      this.stationLineArea = true;
      this.getLineList();
    },
    hideStationLine() {
      this.stationLineArea = false;
    },

    //编辑修改生产线详情窗口
    showStationAddLine(isEdit) {
      this.stationLineAddArea = true;
      if (isEdit) {
        this.stationLineformEdit = true;
        this.stationLineform = this.currentstationLineRow;
      }
    },
    hideStationAddLine() {
      this.stationLineAddArea = false;
    },

    getLineList() {
      let para = {
        key: this.currentRow.Id,
      };
      getSysStationLineListPage(para).then((res) => {
        this.stationLineList = res.data.response.data;
      });
    },

    //修改生产线
    saveStationLineform() {
      this.stationLineform.orgID = this.currentRow.Id;
      this.stationLineform.orgCode = this.currentRow.OrgCode;
      if (this.stationLineformEdit) {
        editSysStationLine(this.stationLineform).then((res) => {
          this.stationLineform = {};
          this.hideStationAddLine();
          this.getLineList();
        });
      } else {
        addSysStationLine(this.stationLineform).then((res) => {
          this.stationLineform = {};
          this.hideStationAddLine();
          this.getLineList();
        });
      }
    },
    removeStationLine(Id) {
      this.$confirm("确认删除选中的记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          deleteSysStationLine([Id]).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            this.stationLineform = {};
            this.getLineList();
          });
        })
        .catch(() => {})
        .finally(() => {
          this.listLoading = false;
        });
    },
    savestationform() {
      if (this.stationform.Id) {
        editSysStation(this.stationform).then((res) => {
          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
          this.stationform = {};
          this.stationArea = false;
        });
      } else {
        addSysStation(this.stationform).then((res) => {
          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
          this.stationform = {};
          this.stationArea = false;
        });
      }
    },
    //格式化时间
    formatCreateTime(row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd hh:mm");
    },
  },
};
</script>

<style scoped>
.inline {
  display: inline-block;
}
</style>
